<template>
    <form-row>
        <div class="flex flex-col sm:flex-row sm:items-end">
            <div class="-mt-4">
                <input-date
                    label="Date"
                    name="site_development_date"
                    v-model="site_development_date"
                    :read_only="read_only"
                    @entered="dateEntered"
                />
            </div>

            <div class="mt-4 sm:mt-0 flex items-center">
                <span class="flex-none text-sm text-gray-warm-800 sm:pl-6 pr-6">
                    {{ $t('- OR -') }}
                </span>

                <div class="flex-none w-16 sm:w-1/5">
                    <input-text
                        name="site_development_period"
                        v-model="site_development_period"
                        placeholder="Days"
                        :read_only="read_only"
                        @input="periodEntered"
                    />
                </div>

                <span class="text-sm text-gray-warm-800 leading-snug pl-4">
                    {{ $t('days after Contract “Binding” Acceptance') }}
                </span>
            </div>
        </div>
    </form-row>
</template>

<script>
import DateFunctions from '../../../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            site_development_date: this.commercial.site_development_date,
            site_development_period: this.commercial.site_development_period,
        }
    },

    computed: {
        site_development_date_from_period() {
            if (! store.state.contract_acceptance_date) {
                return;
            }

            if (this.isValidDate(store.state.contract_acceptance_date) && this.site_development_period) {
                return dayjs(store.state.contract_acceptance_date.slice(0, 10))
                    .add({ day: this.site_development_period })
                    .format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        dateEntered() {
            this.site_development_period = null;
        },
        periodEntered(value) {
            if (! value || ! store.state.contract_acceptance_date) {
                this.site_development_date = null;
            }
        },
    },

    watch: {
        site_development_date_from_period(val) {
            if (val) {
                this.site_development_date = val;
            }
        },
        site_development_date(val) {
            this.$emit('updated', val);
        },
    },
}
</script>
